import { FETCH_BRAND } from '../actions/types';

const INITIAL_STATE = {
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_BRAND:
            return { ...state, name:action.payload };
        default:
            return state;
    }
};
